import { saveToLocalStorage } from "src/utils/localStorage";

const isEmptyTabSettings = (activeSortingColumn, selectedFilters) =>
  !activeSortingColumn && Object.keys(selectedFilters || {}).length === 0;

export const saveLocalProjectSettings = (
  projectId,
  activeSortingColumn,
  activeTab,
  sortingDirection,
  selectedFilters,
) => {
  const prev = localStorage.getItem("ws-project-settings");
  let prevObject = JSON.parse(prev || "[]");
  let result = prevObject.find((project) => project.projectId === projectId);

  // Don't create a new entry just to store default/empty values - every
  // visited campaign used to append one, growing this key without bound.
  if (!result && isEmptyTabSettings(activeSortingColumn, selectedFilters)) {
    return;
  }

  if (!result)
    result = {
      projectId,
      creator: { activeSortingColumn: "", selectedFilters: {} },
      content: { activeSortingColumn: "", selectedFilters: {} },
      action: { activeSortingColumn: "", selectedFilters: {} },
      publication: { activeSortingColumn: "", selectedFilters: {} },
      payment: { activeSortingColumn: "", selectedFilters: {} },
    };

  if (result[activeTab]) {
    result[activeTab].activeSortingColumn = activeSortingColumn;
    result[activeTab].selectedFilters = selectedFilters;
    result[activeTab].sortingDirection = sortingDirection;
  }

  prevObject = prevObject.filter((project) => project.projectId !== projectId);

  saveToLocalStorage("ws-project-settings", [...prevObject, result]);
};
